import Vue, { VNode } from 'vue'

/** 自己创建实现的 */
type HComponent = VNode

type HComponentScopedSlots = (props: any, /** 上一级组件 */ parent: HComponent | undefined) => ScopedSlotReturnValue

type ScopedSlotReturnValue = VNode | string | boolean | null | undefined | ScopedSlotReturnArray

interface ScopedSlotReturnArray extends Array<ScopedSlotReturnValue> {
}

/** 卸载组件 */
export function destroyVComponent(vcomponent: ReturnType<typeof defineVComponent>) {
    vcomponent.$destroy()
    vcomponent.$el.parentElement.removeChild(vcomponent.$el)
}

/** 渲染组件 */
export function renderVComponent(vcomponent: ReturnType<typeof defineVComponent>, to = 'body') {
    /*** 渲染的位置 */
    const showTarget = document.querySelector(to)

    /** 创建渲染容器 */
    const showContainer = document.createElement('div')

    showTarget!.appendChild(showContainer)

    vcomponent.$mount(showContainer)

    return () => {
        destroyVComponent(vcomponent)
    }
}


export function defineVComponent(tag: any, data: {
    /**
     * 如果传入的是ref对象,请保留直接传递ref
     *
     * @example
     * ```js
     * const value = ref(1)
     * defineVComponent(Dialog, { props: { index: value } })
     * ```
     */
    props?: Record<string, any>,

    /** 事件通知 */
    on?: Record<string, (...params: any[]) => void>,

    /** 作用域插槽 */
    scopedSlots?: Record<string, HComponentScopedSlots>
} = {}) {
    const componentTag = Vue.extend(tag)
    const instance = new componentTag({
        propsData: data.props || {},
    })

    // 绑定事件
    Object.keys(data.on || {}).forEach(eventKey => {
        instance.$on(eventKey, data.on[eventKey])
    })

    // 绑定插槽
    // @ts-ignore
    instance.$scopedSlots = ((slots: Record<string, HComponentScopedSlots>) => {
        const scopedSlots = {}

        Object.keys(slots).forEach((key) => {
            scopedSlots[key] = function(props: any) {
                return slots[key].call(this, props, parent)
            }
        })

        return scopedSlots
    })(data.scopedSlots || {})

    return instance
}